import {
  GET_ALL_CHECK_LIST,
  GET_ALL_CHECK_LIST_CASES,
  GET_ALL_CHECK_LIST_CASES_Details,
} from '../types'

const INITIAL_STATE = {
  getAllCheckListUsers: [],
  getAllCheckListCases: [],
  getAllCheckListCasesDetails: [],
}

const checkListReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case GET_ALL_CHECK_LIST:
      return {
        ...state,
        getAllCheckListUsers: payload,
      }

    case GET_ALL_CHECK_LIST_CASES:
      return {
        ...state,
        getAllCheckListCases: payload,
      }

    case GET_ALL_CHECK_LIST_CASES_Details:
      return {
        ...state,
        getAllCheckListCasesDetails: payload,
      }
    default:
      return state
  }
}

export default checkListReducer
